import { Suspense } from "react"

import Section from "./Section"
import { sectionHeaderDefaultClasses } from "./SectionHeader"

import { useAsset } from "web/hooks/data"

export function AssetWithoutFetch({ asset, ...rest }) {
  return (
    <Section
      subjectType="asset"
      data={asset}
      icon="building-office"
      {...rest}
    />
  )
}

export function AssetWithFetch({ assetId, ...rest }) {
  const asset = useAsset(assetId)
  return <AssetWithoutFetch {...rest} asset={asset} />
}

export default function Asset(props) {
  const { asset, assetId } = props

  const hasAsset = !!asset
  const assetIsShallow = hasAsset && asset.is_shallow

  const fetch = !hasAsset || assetIsShallow

  return (
    <Suspense
      fallback={
        <div className={sectionHeaderDefaultClasses}>
          <div className="p-2">Loading Asset Details...</div>
        </div>
      }
    >
      {!fetch && <AssetWithoutFetch {...props} />}
      {fetch && <AssetWithFetch {...props} assetId={assetId || asset.id} />}
    </Suspense>
  )
}
